import AppointmentListTable from "@/app/shared/appointment/appointment-list/list";
import AppointmentListStats from "@/app/shared/appointment/appointment-list/stats";
import { metaObject } from "@/config/site.config";
import AppointmentListPageHeader from "./page-header";

export const metadata = {
    ...metaObject("Appointment List"),
};

export default function AppointmentListPage() {
    return (
        <>
            <AppointmentListPageHeader />
            <div className="space-y-10 @container">
                <AppointmentListStats />
                <AppointmentListTable />
            </div>
        </>
    );
}
